module.exports = __webpack_public_path__ + "images/icon_log_history_small.svg?ce2e808f9bd3810dfb1643aee3fe5828";